<template>
  <div class="investment-template" data-testid="investment-template">
    <main class="investment-template__container">
      <div class="investment-template__content">
        <slot name="default" />
      </div>

      <aside v-if="$slots.sidebar" class="investment-template__sidebar">
        <slot name="sidebar" />
      </aside>
    </main>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class InvestmentContainerTemplate extends Vue {}
</script>

<style lang="less" scoped>
@container-max-width: 1200px;
@account-row-height: 86px;
@navbar-height: 64px;

.investment-template {
  position: relative;
  background: @background-primary;
  min-height: calc(100vh - @navbar-height);

  &__container {
    padding: @size-spacing-x600 @size-spacing-x400 @spacing-xxl;
  }

  &__sidebar {
    margin-top: @size-spacing-x500;
  }

  @media (min-width: 59.375em) /* 950px */ {
    display: flex;
    background: @background-secondary;

    &__container {
      padding: 0;
      margin: 0 auto;
      max-width: @container-max-width;
      display: grid;
      grid-template-areas: 'content . sidebar';
      grid-template-columns: minmax(auto, 700px) minmax(0, @spacing-xxl) 355px;
    }

    &__content {
      grid-area: content;
      padding: @size-spacing-x1000 0 @size-spacing-x600 @size-spacing-x600;
    }

    &__sidebar {
      position: relative;
      margin: 0;
      grid-area: sidebar;
      background: @background-primary;
      border-left: 1px solid @divider-primary;
      border-right: 1px solid @divider-primary;
    }
  }
}
</style>
